if (!window.fetch) window.fetch = require('.').default || require('.');



//////////////////
// WEBPACK FOOTER
// ./node_modules/unfetch/polyfill.js
// module id = 624
// module chunks = 1